import paper from "./textures/paper.webp"
import stone from "./textures/stone.webp"

export type SketchTone = "brand" | "muted" | "stone"

export type SketchTexture = {
  src: string
  opacityClass: string
  width?: number
  height?: number
  pixelRatio?: number
}

export type SketchToneSkin = {
  // Tailwind text-* token: SketchBorder paints with currentColor.
  border: string
  // Tailwind bg-* token for the fill layer.
  fill: string
  texture: SketchTexture
}

export const sketchTones: Record<SketchTone, SketchToneSkin> = {
  brand: {
    border: "text-purple-200",
    fill: "bg-purple-500",
    texture: { src: paper.src, opacityClass: "opacity-30" },
  },
  muted: {
    border: "text-black-ink-800",
    fill: "bg-black-600",
    texture: {
      src: stone.src,
      opacityClass: "opacity-25",
      width: stone.width,
      height: stone.height,
      pixelRatio: 2,
    },
  },
  stone: {
    border: "text-black-ink-800",
    fill: "bg-black-800",
    texture: {
      src: stone.src,
      opacityClass: "opacity-30",
      width: stone.width,
      height: stone.height,
      pixelRatio: 2,
    },
  },
}
